var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import { Route, withRouter } from "react-router";
import { SPEAKER_WHITE_SVG } from "../assets";
import { withToast } from "../HOC";
import { CrateContextConsumer } from "../context";
import { AddToHistory, DynamicPlaylist, PlaybackManager } from "../player";
import { default as SideBar } from "../layout/Sidebar";
import Button from "../components/Button";
import CrateListView from "../components/CrateListView";
import { messages } from "../messages";
var CrateView = /** @class */ (function (_super) {
    __extends(CrateView, _super);
    function CrateView(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            mode: (props.location.state && props.location.state.mode) || 'all',
            downloading: false,
            clearing: false
        };
        return _this;
    }
    CrateView.prototype.componentDidMount = function () {
    };
    CrateView.prototype.playCategory = function (crate, slug) {
        var _this = this;
        var internallist = new DynamicPlaylist([], {
            history_mode: AddToHistory.ALL
        }, 'crate', false);
        internallist.replace(crate.filter(function (item) {
            if (_this.state.mode != 'all' && 'audio' != _this.state.mode) {
                return false;
            }
            if (!slug) {
                return true;
            }
            return item.category.slug == slug;
        }).map(function (album) {
            return {
                album: album,
                track: album.media[0],
                playbackInfo: album.media[0].stream_info,
                playlist: internallist
            };
        }));
        if (internallist.tracks().length > 0) {
            PlaybackManager.getInstance().getContentManager().replaceLists(internallist);
            PlaybackManager.getInstance().startTrack(internallist.tracks()[0]);
        }
    };
    CrateView.prototype.getPages = function (crate) {
        var _this = this;
        var categories = new Array();
        crate.forEach(function (entry) {
            if (_this.state.mode == 'all' || 'audio' == _this.state.mode) {
                categories.push(entry.category);
            }
        });
        categories = categories.unique('slug');
        return [{
                title: messages.All,
                path: undefined,
                render: function (config) {
                    return React.createElement("span", { style: { width: '100%' } },
                        React.createElement("span", { className: "sidebar-text" }, config.title),
                        React.createElement("span", { className: "sidebar-image", onClick: function (e) {
                                e.stopPropagation();
                                _this.playCategory(crate, undefined);
                            } },
                            React.createElement("img", { src: SPEAKER_WHITE_SVG, height: 20 })));
                }
            }].concat(categories.map(function (category) {
            return {
                title: category.name,
                path: category.slug,
                render: function (config) {
                    return React.createElement("span", { style: { width: '100%', display: 'flex' } },
                        React.createElement("span", { className: "sidebar-text" }, config.title),
                        React.createElement("span", { className: "sidebar-image", style: { marginLeft: 'auto', display: 'flex', alignItems: 'center' }, onClick: function (e) {
                                e.stopPropagation();
                                _this.playCategory(crate, category.slug);
                            } },
                            React.createElement("img", { src: SPEAKER_WHITE_SVG, height: 20 })));
                }
            };
        }));
    };
    CrateView.prototype.filterCrate = function (crate) {
        var _this = this;
        if (this.state.mode == 'all' && this.props.match.params.category == undefined) {
            return crate;
        }
        return crate.filter(function (item) {
            if (_this.state.mode != 'all' && 'audio' != _this.state.mode) {
                return false;
            }
            if (_this.props.match.params.category == undefined) {
                return true;
            }
            return item.category.slug == decodeURIComponent(_this.props.match.params.category);
        });
    };
    CrateView.prototype.render = function () {
        var _this = this;
        return React.createElement(CrateContextConsumer, null, function (crate) {
            return React.createElement("div", { className: "crate" },
                React.createElement(SideBar, { pages: _this.getPages(crate), subPage: _this.props.match.params.category ? decodeURIComponent(_this.props.match.params.category) : undefined }),
                React.createElement("div", { className: "sidebar-right-content" },
                    React.createElement("h2", { style: { marginBottom: '40px' } }, messages.YourCrate),
                    crate.length == 0 && React.createElement("h3", null, messages.EmptyCrate),
                    crate.length > 0 && React.createElement("div", null,
                        React.createElement(CrateListView, { albums: _this.filterCrate(crate), context: 'crate', onMediaSelected: _this.props.onMediaSelected, onMediaDownlod: _this.props.onMediaDownlod, onAddToCrate: _this.props.onAddToCrate, onRemoveFromCrate: _this.props.onRemoveFromCrate, onArtistClick: _this.props.onArtistClick, onAlbumSelected: _this.props.onAlbumSelected }),
                        React.createElement("div", { className: "button-actions" },
                            React.createElement(Button, { className: 'hide-mobile', color: 'blue', text: messages.DownloadBatch, loading: _this.state.downloading, disabled: _this.state.clearing || _this.state.downloading, onClick: function (e) {
                                    _this.setState({ downloading: true });
                                    _this.props.onDownload(_this.state.mode, _this.props.match.params.category ? decodeURIComponent(_this.props.match.params.category) : undefined).then(function (downloaded) {
                                    }).finally(function () {
                                        _this.setState({ downloading: false });
                                    });
                                } }),
                            React.createElement(Button, { color: 'blue', text: messages.ClearAll, loading: _this.state.clearing, disabled: _this.state.clearing || _this.state.downloading, onClick: function (e) {
                                    _this.setState({ clearing: true });
                                    _this.props.onClear(_this.state.mode, _this.props.match.params.category ? decodeURIComponent(_this.props.match.params.category) : undefined).then(function (downloaded) {
                                    }).finally(function () {
                                        _this.setState({ downloading: false });
                                    });
                                } })))));
        });
    };
    return CrateView;
}(React.Component));
var CSD = withToast(CrateView);
export default withRouter(/** @class */ (function (_super) {
    __extends(CrateViewRouted, _super);
    function CrateViewRouted() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CrateViewRouted.prototype.render = function () {
        var _this = this;
        return React.createElement(Route, { path: '/:page/:category?', render: function (p) {
                return React.createElement(CSD, __assign({}, _this.props, p, { page: _this.props.match.params.page }));
            } });
    };
    return CrateViewRouted;
}(React.Component)));
//# sourceMappingURL=Crate.js.map


//////////////////
// WEBPACK FOOTER
// ./bpm-web-generic/lib/pages/Crate.js
// module id = 1320
// module chunks = 0